import { render, staticRenderFns } from "./brandPubH5.vue?vue&type=template&id=2e12e577&scoped=true"
import script from "./brandPubH5.vue?vue&type=script&lang=js"
export * from "./brandPubH5.vue?vue&type=script&lang=js"
import style0 from "./brandPubH5.vue?vue&type=style&index=0&id=2e12e577&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12e577",
  null
  
)

export default component.exports